<template>
  <div class="news-wrapper">
    <Votations v-if="owners_association" :owners_association="owners_association"/>
  </div>
</template>
<script>

import Votations from '@/components/Votations/Votations';

export default {

  components:
      {
        Votations,
      },
  computed:
      {
        owners_association() {
          return this.$store.getters.ownersAssociation;
        },
      },

};

</script>
